import React, { useState, useRef, useEffect } from 'react';
import { Country, State, City } from "country-state-city";
import { FaEdit, FaTimes, FaLock, FaUnlock } from 'react-icons/fa';
import { 
  Link, 
  // useNavigate 
} from 'react-router-dom';
// import Mic from "../../images/products/mic.png";
import { FaUserCircle, FaBookmark } from "react-icons/fa";
import { BiCategoryAlt } from "react-icons/bi";
import UserCreateAuction from '../usercreateauction/UserCreateAuction';
import toast from 'react-hot-toast';
import AuctionList from '../usercreateauction/AuctionList';
import UserBidList from "../liveauctionsection/LiveAuctionSection";
import { 
  FaGavel, 
  FaListAlt, 
  // FaEye 
} from "react-icons/fa";
// import ViewAuctions from '../viewactiveauctions/ViewAuctions';
// import { Image } from 'react-bootstrap';


const base_url = process.env.REACT_APP_BASE_URL;

function Profpic() {
  const [activeTab, setActiveTab] = useState('details');
  const [loadingSavedAuctions, setLoadingSavedAuctions] = useState(false);
  const [loadingprivateAuctions, setLoadingprivateAuctions] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [savedAuctions, setSavedAuctions] = useState([]);
  const [privateAuctions, setprivateAuctions] = useState([]);
  const [userData, setUserData] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  
  // Form data state
  const [formData, setFormData] = useState({
    full_name: '',
    occupation: '',
    dob: '',
    gender: '',
    phone: '',
    country: '',
    state: '',
    city: '',
    profile_picture: null
  });

  // Password form state
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: ''
  });

  const [isLoading, setIsLoading] = useState(false);

  const editFormRef = useRef(null);
  const passwordFormRef = useRef(null);
  // const navigate = useNavigate(); 

  // const handleTabClick = (tab) => {
  //   setActiveTab(tab);
  //   if (tab !== 'details') {
  //     setShowEditForm(false);
  //     setShowPasswordForm(false);
  //   }
  // };

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const countryName = Country.getAllCountries().find(country => country.isoCode === countryCode)?.name || '';
    
    setSelectedCountry(countryCode);
    setFormData(prev => ({ ...prev, country: countryName }));
    
    const statesList = State.getStatesOfCountry(countryCode);
    setStates(statesList || []);
    setCities([]);
    setSelectedState("");
    setSelectedCity("");
    setFormData(prev => ({ ...prev, state: '', city: '' }));
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    const stateName = states.find(state => state.isoCode === stateCode)?.name || '';
    
    setSelectedState(stateCode);
    setFormData(prev => ({ ...prev, state: stateName }));
    
    const citiesList = City.getCitiesOfState(selectedCountry, stateCode);
    setCities(citiesList || []);
    setSelectedCity("");
    setFormData(prev => ({ ...prev, city: '' }));
  };

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setSelectedCity(cityName);
    setFormData(prev => ({ ...prev, city: cityName }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const toggleEditForm = async () => {
    if (!showEditForm) {
      // console.log("Populating form with userData:", userData);
      
      // Populate form with current user data when opening
      setFormData({
        full_name: userData?.details?.full_name || userData?.full_name || '',
        occupation: userData?.individual_details?.[0]?.occupation || '',
        dob: userData?.individual_details?.[0]?.dob?.slice(0, 10) || '',
        gender: userData?.individual_details?.[0]?.gender || '',
        phone: userData?.phone || userData?.details?.phone || '',
        country: userData?.country || userData?.details?.country || '',
        state: userData?.state || userData?.details?.state || '',
        city: userData?.city || userData?.details?.city || '',
        profile_picture: null
      });

      // Reset dropdowns first
      setSelectedCountry("");
      setSelectedState("");
      setSelectedCity("");
      setStates([]);
      setCities([]);

      // Set location dropdowns with a small delay to ensure state updates
      setTimeout(() => {
        const userCountry = userData?.country || userData?.details?.country;
        const userState = userData?.state || userData?.details?.state;
        const userCity = userData?.city || userData?.details?.city;

        // console.log("Location data:", { userCountry, userState, userCity });

        if (userCountry) {
          // Try to find country by name first, then by code
          let country = Country.getAllCountries().find(c => 
            c.name.toLowerCase() === userCountry.toLowerCase() || 
            c.isoCode.toLowerCase() === userCountry.toLowerCase()
          );
          
          if (country) {
            // console.log("Found country:", country);
            setSelectedCountry(country.isoCode);
            const statesList = State.getStatesOfCountry(country.isoCode);
            setStates(statesList || []);
            
            if (userState && statesList.length > 0) {
              // Try to find state by name first, then by code
              const state = statesList.find(s => 
                s.name.toLowerCase() === userState.toLowerCase() || 
                s.isoCode.toLowerCase() === userState.toLowerCase()
              );
              
              if (state) {
                // console.log("Found state:", state);
                setSelectedState(state.isoCode);
                const citiesList = City.getCitiesOfState(country.isoCode, state.isoCode);
                setCities(citiesList || []);
                
                if (userCity) {
                  // console.log("Setting city:", userCity);
                  setSelectedCity(userCity);
                }
              } else {
                console.log("State not found:", userState, "Available states:", statesList.map(s => s.name));
              }
            }
          } else {
            console.log("Country not found:", userCountry, "Available countries:", Country.getAllCountries().slice(0, 5).map(c => c.name));
          }
        }
      }, 100);
    }
    
    setShowEditForm(!showEditForm);
     setShowPasswordForm(false);
  };

  const togglePasswordForm = () => {
    setShowPasswordForm(!showPasswordForm);
    setShowEditForm(false);
    if (!showPasswordForm) {
      setPasswordData({ current_password: '', new_password: '' });
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
  
    try {
      const token = localStorage.getItem('token');

      const requestBody = {
        user_id: userData?.id || userData?.details?.id, 
        full_name: formData.full_name,
        phone: formData.phone,
        country: formData.country,
        state: formData.state,
        city: formData.city
      };
  
     
      Object.keys(requestBody).forEach(key => {
        if (requestBody[key] === null || requestBody[key] === '' || requestBody[key] === undefined) {
          delete requestBody[key];
        }
      });
  
      // console.log("Sending request body:", requestBody);
  
      const response = await fetch(`${base_url}/api/user/userProfileEdit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(requestBody)
      });
  
      const result = await response.json();
      // console.log("API Response:", result);
  
      if (response.ok) {
        alert('Profile updated successfully!');
        setShowEditForm(false);
        fetchUserData();
      } else {
        alert(`Error: ${result.message || result.error || 'Failed to update profile'}`);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert('An error occurred while updating the profile');
    } finally {
      setIsLoading(false);
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab !== 'details') {
      setShowEditForm(false);
      setShowPasswordForm(false);
    }
   
    if (tab === 'change password') {
      fetchSavedAuctions();
    }
    if (tab === 'edit') {
      fetchprivateAuctions();
    }
  };
  const fetchprivateAuctions = async () => {
    if (!userData?.id) return;
    
    setLoadingSavedAuctions(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await fetch(`${base_url}/api/auction/getInvitedPrivateAuctionList`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const result = await response.json();
      
      if (response.ok && result.status === 200) {
        setprivateAuctions(result.data || []);
        
      } else {
        console.error("Failed to fetch saved auctions:", result.message);
        toast.error("Failed to load saved auctions");
      }
    } catch (error) {
      console.error("Error fetching saved auctions:", error);
      toast.error("Error loading saved auctions");
    } finally {
      setLoadingprivateAuctions(false);
    }
  };
  
  const fetchSavedAuctions = async () => {
    if (!userData?.id) return;
    
    setLoadingSavedAuctions(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await fetch(`${base_url}/api/auction/getSavedAuction?id=${userData.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const result = await response.json();
      
      if (response.ok && result.status === 200) {
        setSavedAuctions(result.data || []);
      } else {
        console.error("Failed to fetch saved auctions:", result.message);
        toast.error("Failed to load saved auctions");
      }
    } catch (error) {
      console.error("Error fetching saved auctions:", error);
      toast.error("Error loading saved auctions");
    } finally {
      setLoadingSavedAuctions(false);
    }
  };
  

  const handleRemoveAuction = async (auctionId) => {
    const token = localStorage.getItem('token');
    
    try {
      const response = await fetch(`${base_url}/api/auction/saveAuction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          auction_id: auctionId,
          status: 0
        })
      });
      
      const result = await response.json();
      
      if (response.ok) {
        toast.success("Auction removed successfully!");
        setSavedAuctions(prevAuctions => 
          prevAuctions.filter(auction => auction.auction_id !== auctionId)
        );
        
        // Update localStorage to remove the auction
        const saved = localStorage.getItem("savedAuctions");
        if (saved) {
          try {
            const savedIds = JSON.parse(saved);
            const updatedSavedIds = savedIds.filter(id => id !== auctionId);
            localStorage.setItem("savedAuctions", JSON.stringify(updatedSavedIds));
          } catch (err) {
            console.error("Error updating saved auctions in localStorage:", err);
          }
        }
        
        const event = new CustomEvent('auctionRemoved', {
          detail: { auctionId }
        });
        window.dispatchEvent(event);
        
      } else {
        console.error("Failed to remove auction:", result.message);
        toast.error("Failed to remove auction");
      }
    } catch (error) {
      console.error("Error removing auction:", error);
      toast.error("Error removing auction");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${base_url}/api/user/changePassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(passwordData)
      });

      const result = await response.json();

      if (response.ok) {
        alert('Password changed successfully!');
        setShowPasswordForm(false);
        setPasswordData({ current_password: '', new_password: '' });
      } else {
        alert(`Error: ${result.message || result.error || 'Failed to change password'}`);
      }
    } catch (error) {
      console.error("Error changing password:", error);
      alert('An error occurred while changing the password');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserData = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${base_url}/api/user/userProfileGet`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const result = await response.json();
      const data = result.data;
      if (response.ok) {
        setUserData(data);
      } else {
     
      }
    } catch  {
      
    }
  };

  useEffect(() => {
    if (showEditForm && editFormRef.current) {
      editFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if (showPasswordForm && passwordFormRef.current) {
      passwordFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [showEditForm, showPasswordForm]);

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    if (userData) {
     
    }
  }, [userData]);

  return (
    <div className="bg-light min-vh-100">
      {/* Cover Photo */}
      <div className="position-relative">
        <img
          src="https://wallpapercave.com/wp/p38Ujl2.jpg"
          alt="Cover"
          className="img-fluid w-100"
          style={{ height: '300px', objectFit: 'cover' }}
        />
        <div className="position-absolute" style={{ bottom: '-60px', left: '40px' }}>
          <div className="border border-white rounded-circle overflow-hidden" style={{ width: '120px', height: '120px' }}>
            {/* <img
              src="https://alljapantours.com/php17/interfaceMaster/blogMaster/img17/photo/blog/src/COCD20791543.jpg"
              alt="Avatar"
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
            /> */}
           <img
      src={userData?.details?.profile_pic}
      alt="Profile Picture"
      className="w-100 h-100"
      style={{ objectFit: 'cover' }}
      onError={(e) => {
        e.target.src = '/default-avatar.png'; // fallback image
      }}
    />
          </div>
        </div>
      </div>

      <div className="bg-white mt-5 p-4 shadow-sm container rounded text-black rounded-lg ">
        <div className="row align-items-center justify-content-between">
          <div className="col-md-6">
            <h3 className="mb-0">{userData?.details?.full_name || 'Name not available'}</h3>
            <small className="text-black">{userData?.email || 'Email not available'}</small>
          </div>
        </div>

        {/* Tabs */}
        <ul className="nav nav-tabs mt-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'details' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('details')}
            type="button"
          >
            <FaUserCircle className="me-2" />
            Account Information
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'edit' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('edit')}
            type="button"
          >
            <BiCategoryAlt className="me-2" />
            Private Auction
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'change password' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('change password')}
            type="button"
          >
            <FaBookmark className="me-2" />
            Saved Auctions
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'user create auction' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('user create auction')}
            type="button"
          >
            <FaGavel className="me-2" />
            Create Auction
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'Auction List' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('Auction List')}
            type="button"
          >
            <FaListAlt className="me-2" />
            Created Auction List
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'user bid list' ? 'active' : ''} text-black`}
            onClick={() => handleTabClick('user bid list')}
            type="button"
          >
            <FaListAlt className="me-2" />
            Bids List
          </button>
        </li>
      </ul>

        {/* Account Info Section */}
        {activeTab === 'details' && (
          <>
            <div className="row align-items-start justify-content-between border border-grey">
              <div className="col-md-6 p-4">
                <h5 className='fw_600'>User Details</h5>
                <div className='mx-3'>
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <p><strong>Full Name:</strong> <br />{userData?.details?.full_name}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>Email:</strong> <br />{userData?.email}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>Profile Type:</strong><br />{userData?.details?.profile_type}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <p><strong>Gender:</strong> <br />{userData?.individual_details?.[0]?.gender}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>Date of Birth:</strong><br />{userData?.individual_details?.[0]?.dob?.slice(0,10)}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>Occupation:</strong><br />{userData?.individual_details?.[0]?.occupation}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <p><strong>Phone:</strong> <br />{userData?.phone || userData?.details?.phone || 'Not provided'}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>Country:</strong><br />{userData?.country || userData?.details?.country || 'Not provided'}</p>
                    </div>
                    <div className="col-md-4">
                      <p><strong>State:</strong><br />{userData?.state || userData?.details?.state || 'Not provided'}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <p><strong>City:</strong> <br />{userData?.city || userData?.details?.city || 'Not provided'}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 text-md-end mt-3 mt-md-0">
                <div className="d-flex justify-content-md-end gap-1 flex-wrap">
                  <button
                    type="button"
                    onClick={toggleEditForm}
                    className="btn login-btn text-white position-relative overflow-hidden"
                    style={{ fontSize: "15px", fontFamily: "inherit" }}
                    disabled={isLoading}
                  >
                    <div className="swift-btn_animation d-flex justify-content-center align-items-center log_cus gap-2">
                      {showEditForm ? <FaTimes color="black" /> : <FaEdit color="black" />}
                      <p className="m-0 text-black">{showEditForm ? 'Close Edit' : 'Edit Profile'}</p>
                    </div>
                  </button>

                  <button
                    type="button"
                    onClick={togglePasswordForm}
                    className="btn login-btn text-white position-relative overflow-hidden"
                    style={{ fontSize: "15px", fontFamily: "inherit" }}
                    disabled={isLoading}
                  >
                    <div className="swift-btn_animation d-flex justify-content-center align-items-center log_cus gap-2">
                      {showPasswordForm ? <FaUnlock color="black" /> : <FaLock color="black" />}
                      <p className="m-0 text-black">{showPasswordForm ? 'Close Password' : 'Change Password'}</p>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            {/* Edit Form */}
          {showEditForm && (
            <div className="p-4" ref={editFormRef}>
              <h5 className='fw_600'>Edit Details</h5>
              <form className="text-black mx-3" onSubmit={handleEditSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Full Name</label>
                    <input 
                      type="text" 
                      name="full_name"
                      className="form-control" 
                      placeholder="Enter Full Name"
                      value={formData.full_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone Number</label>
                    <input 
                      type="tel" 
                      name="phone"
                      className="form-control" 
                      placeholder="Enter phone number"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="mb-2">Country</label>
                    <select
                      name="country"
                      className="form-control"
                      value={selectedCountry}
                      onChange={handleCountryChange}
                    >
                      <option value="">Select Country</option>
                      {Country.getAllCountries().map((country) => (
                        <option key={country.isoCode} value={country.isoCode}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {selectedCountry && (
                      <small className="text-muted">
                        Selected: {Country.getAllCountries().find(c => c.isoCode === selectedCountry)?.name}
                      </small>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="mb-2">State</label>
                    <select
                      name="state"
                      className="form-control"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={!selectedCountry}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.isoCode} value={state.isoCode}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    {selectedState && (
                      <small className="text-muted">
                        Selected: {states.find(s => s.isoCode === selectedState)?.name}
                      </small>
                    )}
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="mb-2">City</label>
                    <select
                      name="city"
                      className="form-control"
                      value={selectedCity}
                      onChange={handleCityChange}
                      disabled={!selectedState}
                    >
                      <option value="">Select City</option>
                      {cities.map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                    {selectedCity && (
                      <small className="text-muted">
                        Selected: {selectedCity}
                      </small>
                    )}
                  </div>
                </div>

                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-golden-glass text-white position-relative overflow-hidden border-0"
                    disabled={isLoading}
                  >
                    <div
                      className=" d-flex justify-content-center align-items-center"
                      
                    >
                      <p className="m-0 text-black fw-bold button_name">
                        {isLoading ? 'Saving...' : 'Save Changes'}
                      </p>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Password Form */}
          {showPasswordForm && (
            <div className="p-4" ref={passwordFormRef}>
              <h5 className='fw_600'>Change Password</h5>
              <form className="text-black mx-3" onSubmit={handlePasswordSubmit}>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Current Password</label>
                    <input 
                      type="password" 
                      name="current_password"
                      className="form-control" 
                      placeholder="Enter current password"
                      value={passwordData.current_password}
                      onChange={handlePasswordChange}
                      required
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">New Password</label>
                    <input 
                      type="password" 
                      name="new_password"
                      className="form-control" 
                      placeholder="Enter new password"
                      value={passwordData.new_password}
                      onChange={handlePasswordChange}
                      required
                    />
                  </div>
                </div>
                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-golden-glass text-white position-relative overflow-hidden border-0"
                    disabled={isLoading}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                   
                    >
                      <p className="m-0 text-black fw-bold button_name">
                        {isLoading ? 'Changing...' : 'Change Password'}
                      </p>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          )}
        </>
      )}

      {/* Followed Category Tab */}
      {/* {activeTab === 'edit' && (
        <section className='sec_pd'>
        <div className="p-4">
           <h5 className='fw_600 mb-4'>Private Auctions</h5>
           
           {loadingprivateAuctions ? (
             <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
               <div className="spinner-border text-primary" role="status">
                 <span className="visually-hidden">Loading...</span>
               </div>
             </div>
           ) : privateAuctions.length > 0 ? (
             <div className="row">
               {privateAuctions.map((auction) => (
                 <div key={auction.saved_id} className="col-lg-4 col-md-6 mb-4">
                   <div className="card h-100 shadow-sm">
                     <img
                       src={auction.images?.image[0]}
                       alt={auction.title}
                       className="card-img-top"
                       style={{ height: '200px', objectFit: 'cover' }}
                     />
                     <div className="card-body">
                       <h6 className="card-title text-dark">{auction.title}</h6>
                       <div className="d-flex justify-content-end align-items-center">
                         <button 
                           className="btn btn-dark text-warning btn-sm"
                           onClick={() => handleRemoveAuction(auction.auction_id)}
                         >
                           Remove
                         </button>
                       </div>
                     </div>
                   </div>
                 </div>
               ))}
             </div>
           ) : (
             <div className="d-flex justify-content-center align-items-center text-center" style={{ minHeight: '400px' }}>
               <div>
                 <div className="mb-3">
                   <FaBookmark size={60} className="text-muted" />
                 </div>
                 <h4 className="text-dark mb-3">No Saved Auctions</h4>
                 <p className="text-muted mb-4">You haven't saved any auctions yet. Start exploring and save your favorite auctions!</p>
                 <Link
                   to='/home'
                   className="btn signup-btn text-white position-relative overflow-hidden border-0"
                 >
                   <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                     <p className="m-0 text-black fw-bold button_name">
                       Explore Auctions
                     </p>
                   </div>
                 </Link>
               </div>
             </div>
           )}
         </div>
     </section>
      )} */}
      {activeTab === 'edit' && (
  <section className='sec_pd'>
    <div className="p-4">
      <h5 className='fw_600 mb-4'>Private Auctions</h5>
      
      {loadingprivateAuctions ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : privateAuctions.length > 0 ? (
        <div className="row">
         {privateAuctions.map((item) => (
  <div key={item.id} className="col-lg-4 col-md-6 mb-4">
    <div className="card card_floral floral-border  h-100 shadow-sm">
      <Link to={`/privateauctiondetails/${item.auction_id}`} className="text-decoration-none">
        <img
          src={item.auction?.images?.[0]?.image || '/placeholder-image.jpg'}
          alt={item.auction?.title || 'Auction item'}
          className="card-img-top"
          style={{ height: '200px', objectFit: 'cover' }}
          onError={(e) => {
            e.target.src = '/placeholder-image.jpg';
          }}
        />
      </Link>
      <div className="card-body ">
        <Link to={`/privateauctiondetails/${item.auction_id}`} className="text-decoration-none">
          <h6 className="card-title text-dark">{item.auction?.title || 'Untitled Auction'}</h6>
        </Link>
        <Link to={`/privateauctiondetails/${item.auction_id}`} className="text-decoration-none">
          <p className="card-text text-muted small">
            Artist: {item.auction?.details?.artist || 'Unknown'}
          </p>
        </Link>
        <Link to={`/privateauctiondetails/${item.auction_id}`} className="text-decoration-none">
          <p className="card-text text-muted small">
            Material: {item.auction?.details?.material || 'Not specified'}
          </p>
        </Link>
       
       
      </div>
    </div>
  </div>
))}
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center text-center" style={{ minHeight: '400px' }}>
          <div>
            <div className="mb-3">
              <FaBookmark size={60} className="text-muted" />
            </div>
            <h4 className="text-dark mb-3">No Private Auctions</h4>
            <p className="text-muted mb-4">You haven't been invited to any private auctions yet.</p>
            <Link
              to='/home'
              className="btn signup-btn text-white position-relative overflow-hidden border-0"
            >
              <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                <p className="m-0 text-black fw-bold button_name">
                  Explore Auctions
                </p>
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  </section>
)}

      {/* Saved Auctions Tab */}
      {activeTab === 'change password' && (
        <section className='sec_pd'>
           <div className="p-4">
              <h5 className='fw_600 mb-4'>Saved Auctions</h5>
              
              {loadingSavedAuctions ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : savedAuctions.length > 0 ? (
                <div className="row">
                  {savedAuctions.map((auction) => (
  <div key={auction.saved_id} className="col-lg-4 col-md-6 mb-4">
    <div className="card card_floral floral-border h-100 shadow-sm">
      <Link to={`/savedauctiondetails/${auction.auction_id}`}>
        <img
          src={auction.image}
          alt={auction.title}
          className="card-img-top"
          style={{ height: '200px', objectFit: 'cover', cursor: 'pointer' }}
        />
      </Link>
      <div className="card-body">
        {/* Make the title clickable */}
           <Link to={`/savedauctiondetails/${auction.auction_id}`} className="text-decoration-none">
          <h6 className="card-title text-dark">{auction.title}</h6>
                 </Link>
                <div className="d-flex justify-content-end align-items-center">
              
                  <button
                    className="btn btn-golden-glass   text-white btn-sm"
                    onClick={() => handleRemoveAuction(auction.auction_id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center text-center" style={{ minHeight: '400px' }}>
                  <div>
                    <div className="mb-3">
                      <FaBookmark size={60} className="text-muted" />
                    </div>
                    <h4 className="text-dark mb-3">No Saved Auctions</h4>
                    <p className="text-muted mb-4">You haven't saved any auctions yet. Start exploring and save your favorite auctions!</p>
                    <Link
                      to='/home'
                      className="btn signup-btn text-white position-relative overflow-hidden border-0"
                    >
                      <div className="swift-btn_animation d-flex justify-content-center align-items-center" style={{background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))", }}>
                        <p className="m-0 text-black fw-bold button_name">
                          Explore Auctions
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
            </div>
        </section>
      )}

      {/* User Create Auction Tab */}
      {activeTab === 'user create auction' && (
        <section className='sec_pd'>
          <div className="p-4 pt-3">
            {/* Add your UserCreateAuction component here */}
            <div className="text-center ">
              <UserCreateAuction />
            </div>
          </div>
        </section>
      )}

      {/* Auction List Tab */}
      {activeTab === 'Auction List' && (
        <section className='sec_pd'>
          <div className="p-4">
            {/* Add your AuctionList component here */}
            <div className="text-center">
          
              <AuctionList />
            </div>
          </div>
        </section>
      )}

      {activeTab === 'user bid list' && (
        <section className='sec_pd'>
          <div className="p-4">
            {/* Add your UserBidList component here */}
            <div className="text-center">
          
              <UserBidList />
            </div>
          </div>
        </section>
      )}

      

      
        
      </div>
    </div>
  );
}

export default Profpic;